(function () {
    'use strict';

    angular.module("imApp").factory("discGrpCustService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 3119,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 3120,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
